import styled from "@emotion/styled";
import { physioMeTabletBreakpoint, stack } from "@ui/style";
import React, { useEffect, useState } from "react";
import { DIALOG_SIZE } from "@ui/components/dialog/base-dialog";
import { analyticsService, userSurveyManager } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import { Survey, SURVEY_COMPLETION_POSTMESSAGE } from "@domain/user/user-survey";
import { useDimensions } from "@ui/hooks/use-dimensions";

interface CreateSurveyFormProps {
	setWidth: React.Dispatch<React.SetStateAction<DIALOG_SIZE>>;
	setHeight: React.Dispatch<React.SetStateAction<string>>;
	survey: Survey;
}

const completeSurvey = async (survey: Survey) => {
	(async () => await userSurveyManager.completeSurvey(survey.id))();

	analyticsService.trackEvent({
		category: AnalyticsCategory.SURVEY,
		action: "completedSurvey",
		params: [survey.title],
	});
};

export const CreateSurveyForm: React.FC<CreateSurveyFormProps> = ({ survey, setWidth, setHeight }) => {
	const [iframeHeight, setIframeHeight] = useState(450);
	const { isMobile } = useDimensions();

	useEffect(() => {
		const handleIFrameMessage = async (event: MessageEvent) => {
			// Message from thank-you-survey page
			if (event.origin === window.location.origin && event.data === SURVEY_COMPLETION_POSTMESSAGE) {
				await completeSurvey(survey);
			}
		};
		window.addEventListener("message", handleIFrameMessage);

		analyticsService.trackEvent({
			category: AnalyticsCategory.SURVEY,
			action: "modaleMainCta",
			params: [survey.title],
		});

		if (isMobile) {
			setIframeHeight(window.innerHeight - 120);
		} else {
			setIframeHeight(window.innerHeight - 220);
		}

		return () => {
			window.removeEventListener("message", handleIFrameMessage);
		};
	}, [isMobile, survey]);

	useEffect(() => {
		setWidth(DIALOG_SIZE.XL);
		setHeight(window.innerHeight - 110 + "px");
	}, [setWidth, setHeight]);

	return (
		<Container>
			<StyledIframe src={survey.link} height={iframeHeight} scrolling="auto"></StyledIframe>
		</Container>
	);
};

const Container = styled.div`
	${stack("L", "flexstart", "center")}
	text-align: center;
	padding-top: 0px;
`;

const StyledIframe = styled.iframe`
	border: none;
	width: 100%;
	min-width: 650px;

	@media ${physioMeTabletBreakpoint} {
		min-width: unset;
	}
`;
